import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/core/assets/logo.png'


const _hoisted_1 = { class: "cd-sidenav-menu-heading" }
const _hoisted_2 = { class: "cd-sidenav-menu-heading" }
const _hoisted_3 = { class: "cd-sidenav-menu-heading" }
const _hoisted_4 = { class: "cd-sidenav-menu-heading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppSidebar = _resolveComponent("AppSidebar")!
  const _component_BNav = _resolveComponent("BNav")!
  const _component_BOffcanvas = _resolveComponent("BOffcanvas")!
  const _component_DBUploadPage = _resolveComponent("DBUploadPage")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_feature = _resolveDirective("feature")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.shouldRender)
      ? (_openBlock(), _createBlock(_component_BOffcanvas, {
          key: 0,
          backdrop: "true",
          "backdrop-variant": "dark",
          "backdrop-class": "shadow-lg",
          header: "false",
          modelValue: _ctx.isVisibleUi,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isVisibleUi) = $event)),
            _ctx.handleBackdropClick
          ],
          placement: "start",
          style: {"background-color":"#eaeaea"},
          class: _normalizeClass({ 'slide-in': _ctx.isVisibleUi, 'slide-out': !_ctx.isVisibleUi })
        }, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"position":"absolute","width":"0","height":"0"} }, null, -1)),
            _createVNode(_component_BNav, { class: "cd-sidenav-menu" }, {
              default: _withCtx(() => [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "coats-logo" }, [
                  _createElementVNode("div", { class: "p-4" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Seamworks Logo"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("headerSideMenuV1.menu")), 1),
                _createVNode(_component_router_link, {
                  to: { name: 'Dashboard' },
                  class: "cd-sidenav-nav-link nav-link",
                  onClick: _ctx.handleLinkClick
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      fixedWidth: true,
                      icon: ['fas', 'tachometer-alt']
                    }),
                    _createTextVNode(_toDisplayString(_ctx.$t("headerSideMenuV1.dashboard")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_AppSidebar, { onClick: _ctx.handleLinkClick }, null, 8, ["onClick"]),
                (Number(_ctx.getAccountType()) == 101 && _ctx.tenantSettingsLoaded && !_ctx.isV4CalculationEngine)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "cd-sidenav-nav-link nav-link",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleUploadClick && _ctx.handleUploadClick(...args))),
                      style: {"padding-right":"5px","cursor":"pointer"}
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        fixedWidth: true,
                        icon: ['fas', 'upload']
                      }),
                      _createTextVNode(_toDisplayString(_ctx.$t("headerSideMenuV1.uploadSeamworksDatabase")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (false && _ctx.hasAnySystemPermissions)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("headerSideMenuV1.system")), 1),
                      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                        to: { name: 'SystemUsersGrid' },
                        class: "cd-sidenav-nav-link nav-link",
                        onClick: _ctx.handleLinkClick
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            fixedWidth: true,
                            icon: "users"
                          }),
                          _createTextVNode(_toDisplayString(_ctx.$t("headerSideMenuV1.systemUsers")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_permission, 'AbpIdentity.Users']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                        to: { name: 'SystemRolesGrid' },
                        class: "cd-sidenav-nav-link nav-link",
                        onClick: _ctx.handleLinkClick
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            fixedWidth: true,
                            icon: "shield-alt"
                          }),
                          _createTextVNode(_toDisplayString(_ctx.$t("headerSideMenuV1.systemRoles")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_permission, 'AbpIdentity.Roles']
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.hasAnySaasPermissions)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("headerSideMenuV1.saas")), 1),
                      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                        to: { name: 'HostFeaturesForm' },
                        class: "cd-sidenav-nav-link nav-link",
                        onClick: _ctx.handleLinkClick
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            fixedWidth: true,
                            icon: "desktop"
                          }),
                          _createTextVNode(_toDisplayString(_ctx.$t("headerSideMenuV1.hostFeatures")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_permission, 'FeatureManagement.ManageHostFeatures']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                        to: { name: 'TenantsGrid' },
                        class: "cd-sidenav-nav-link nav-link",
                        onClick: _ctx.handleLinkClick
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            fixedWidth: true,
                            icon: "cogs"
                          }),
                          _createTextVNode(_toDisplayString(_ctx.$t("headerSideMenuV1.tenants")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_permission, 'AbpTenantManagement.Tenants']
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.hasAnyDebugFeature)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("headerSideMenuV1.debug")), 1),
                      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                        to: { name: 'AuthInfo' },
                        class: "cd-sidenav-nav-link nav-link",
                        onClick: _ctx.handleLinkClick
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.hasAnyDebugFeature) + " ", 1),
                          _createVNode(_component_font_awesome_icon, {
                            fixedWidth: true,
                            icon: "key"
                          }),
                          _createTextVNode(_toDisplayString(_ctx.$t("headerSideMenuV1.authInfo")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [
                          _directive_feature,
                          'CoatsDigitalCore.DisplayAuthDebug',
                          void 0,
                          { bool: true }
                        ]
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "class"]))
      : _createCommentVNode("", true),
    (_ctx.showUploadModal)
      ? (_openBlock(), _createBlock(_component_DBUploadPage, {
          key: 1,
          showModal: _ctx.showUploadModal,
          onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showUploadModal = false))
        }, null, 8, ["showModal"]))
      : _createCommentVNode("", true)
  ], 64))
}